import * as React from 'react';
import './WYSIWYGEditor.scss';
import Link from '@tiptap/extension-link';
import Underline from '@tiptap/extension-underline';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

interface TipTapProps {
  content: string;
  disabled: boolean;
  readonly?: boolean;
  onChange?: any;
  isFullscreen?: boolean;
  onClickLink?: string;
}

const baseExtensions = [
  StarterKit.configure({
    bulletList: {
      keepMarks: true,
      keepAttributes: false
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false
    }
  }),
  Underline.configure({})
];

const readOnlyExtensions = [
  ...baseExtensions,
  Link.configure({
    openOnClick: true,
    HTMLAttributes: {
      rel: null,
      target: '_blank'
    }
  })
];

export const ROWYSIWYGEditor = ({ content, onClickLink }: TipTapProps) => {
  const readonlyContent = content?.replaceAll(
    'target="_self"',
    'target="_blank"'
  );
  const readOnlyExtensionsLink = [
    ...baseExtensions,
    Link.configure({
      openOnClick: true,
      HTMLAttributes: {
        rel: null,
        target: '_blank',
        onclick: onClickLink
      }
    })
  ];
  const editor = useEditor({
    extensions: onClickLink ? readOnlyExtensionsLink : readOnlyExtensions,
    content: readonlyContent,
    editable: false
  });

  React.useEffect(() => {
    editor?.commands?.setContent(readonlyContent);
  }, [content]);

  return (
    <div className="editor-wrapper scrollable">
      <EditorContent editor={editor} editable={false} className={'readonly'} />
    </div>
  );
};
